export default __webpack_public_path__ + "images/3fb7da8b57d114653b98b46fd262ce4d-ticketsSvg.svg";